import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "[mumtahin-gallery] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY সেট নেই — " +
      ".env ফাইলে বসান (দেখুন .env.example), নাহলে গ্যালারি খালি দেখাবে।"
  );
}

// createClient খালি URL পেলে import-এর সময়েই throw করে — তাতে env না থাকলে পুরো সাইট সাদা হয়ে যায়।
// তাই fallback হিসেবে কখনো resolve না হওয়া (.invalid) একটা ঠিকানা দেওয়া হয়: সব query দ্রুত fail করে
// আর প্রতিটা পেজ নিজের "লোড করা যাচ্ছে না" অবস্থা দেখায়।
export const supabase = createClient(supabaseUrl || "https://placeholder.invalid", supabaseAnonKey || "placeholder");

export const PAPERS_TABLE = "shared_papers";
